var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "bj-query-form bj-query-form-for-cal-height form",
      attrs: { size: "mini", model: _vm.form, rules: _vm.rules },
    },
    [
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Client"),
                    prop: "clientCode",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.clientCodeList,
                      placeholder: _vm.$t("chooseText"),
                    },
                    model: {
                      value: _vm.form.clientCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "clientCode", $$v)
                      },
                      expression: "form.clientCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SalesOrderToBeApproved.SKU"),
                    prop: "skuCode",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                    model: {
                      value: _vm.form.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "skuCode", $$v)
                      },
                      expression: "form.skuCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.quantity"),
                    prop: "quantity",
                  },
                },
                [
                  _c("BjInputMoney", {
                    attrs: { placeholder: _vm.$t("inputText"), clearable: "" },
                    model: {
                      value: _vm.form.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quantity", $$v)
                      },
                      expression: "form.quantity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.yearAndWeek"),
                    prop: "year",
                  },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "getWeekDate",
                      "picker-options": { firstDayOfWeek: 1 },
                      type: "week",
                      format: "yyyy-WW",
                      clearable: false,
                      placeholder: _vm.$t("billingPage.yearAndWeeks"),
                    },
                    on: { change: _vm.dataChange },
                    model: {
                      value: _vm.weekDataNow,
                      callback: function ($$v) {
                        _vm.weekDataNow = $$v
                      },
                      expression: "weekDataNow",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.description"),
                    prop: "description",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.BILLMAX,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }